var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocumentUploadActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.7512 2.16663C18.8345 2.16663 18.9176 2.16946 19.0002 2.17508V8.49996C19.0002 10.525 20.6418 12.1666 22.6668 12.1666H27.6668V24.5C27.6668 27.9978 24.8313 30.8333 21.3335 30.8333H10.6668C7.16903 30.8333 4.3335 27.9978 4.3335 24.5V8.49996C4.3335 5.00216 7.16903 2.16663 10.6668 2.16663H18.7512ZM26.817 9.78475C26.9184 9.90649 27.0114 10.0341 27.0956 10.1666H22.6668C21.7464 10.1666 21.0002 9.42043 21.0002 8.49996V2.93732C21.2068 3.09779 21.3974 3.2813 21.568 3.48595L26.817 9.78475Z",
    fill: "#924D27"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentUploadActive);
export default __webpack_public_path__ + "static/media/document-upload-active.d15c81192c520816320b0b702538acfa.svg";
export { ForwardRef as ReactComponent };